import { css } from '@styled-system/css';
import type { FC } from 'react';

interface MenuCloseButtonProps {
  onClick: () => void;
  className?: string;
}

const CloseIcon: FC<{ className?: string }> = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path
      d="M1.37087 11.7418L11.7418 1.37089M1.37087 1.37089L11.7418 11.7418"
      stroke="#E6E6E9"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuCloseButton: FC<MenuCloseButtonProps> = ({ onClick, className }) => {
  const buttonStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    w: '22px',
    h: '22px',
    bg: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    transition: 'opacity 0.2s',
    _hover: {
      opacity: 0.7,
    },
  });

  const iconStyles = css({
    w: '0.9167rem', // 14.667px
    h: '0.9167rem', // 14.667px
  });

  return (
    <button className={`${buttonStyles} ${className || ''}`} onClick={onClick} aria-label="Fermer">
      <CloseIcon className={iconStyles} />
    </button>
  );
};
